import React, { useEffect, useState } from "react";
import { Tag, Clock } from "lucide-react";

function formatRemaining(expiresAt) {
  const diffMs = new Date(expiresAt).getTime() - Date.now();
  if (diffMs <= 0) return null;
  const totalMinutes = Math.floor(diffMs / 60000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  if (days > 0) return `${days}d ${hours}h remaining`;
  if (hours > 0) return `${hours}h ${minutes}m remaining`;
  return `${minutes}m remaining`;
}

// Live countdown banner for an active company promo code ({promoCode,
// promoDiscountPercent, promoExpiresAt, daysRemaining}). Renders nothing if
// `promo` is falsy — callers pass the `promo` field straight from
// creditsApi.balance() (null when there's no active promo).
export function PromoBanner({ promo, className = "" }) {
  const [remaining, setRemaining] = useState(() => (promo ? formatRemaining(promo.promoExpiresAt) : null));

  useEffect(() => {
    if (!promo) return;
    setRemaining(formatRemaining(promo.promoExpiresAt));
    const id = setInterval(() => setRemaining(formatRemaining(promo.promoExpiresAt)), 30000);
    return () => clearInterval(id);
  }, [promo]);

  if (!promo || !remaining) return null;

  return (
    <div
      data-testid="promo-banner"
      className={`flex flex-wrap items-center gap-2.5 rounded-xl border border-amber-300 bg-gradient-to-r from-amber-50 to-orange-50 px-4 py-2.5 text-[13px] ${className}`}
    >
      <Tag className="h-4 w-4 text-amber-600 shrink-0" />
      <span className="font-mono font-bold tracking-wide text-amber-800 bg-amber-100 px-2 py-0.5 rounded" data-testid="promo-banner-code">
        {promo.promoCode}
      </span>
      <span className="font-semibold text-amber-800" data-testid="promo-banner-discount">
        {promo.promoDiscountPercent}% off AI Credits
      </span>
      <span className="inline-flex items-center gap-1 text-amber-700" data-testid="promo-banner-countdown">
        <Clock className="h-3.5 w-3.5" /> {remaining}
      </span>
    </div>
  );
}

export default PromoBanner;
